import { useState } from 'react';
import copy from 'copy-to-clipboard';
import {
  IconUp,
  IconDown,
  ButtonSecondary,
  ButtonSize,
  IconDownload,
  ButtonPseudo,
  IconCopy,
  IconSend,
} from '@ui/src';
import { PspPartnerPaymentType } from '../hoc/types';
import { TopUpInstructionsItemTypes } from './types';

import cn from './messages.module.css';

const getPspPartnerPaymentType = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerPaymentType.BACS:
      typeName = 'BACS';
      break;
    case PspPartnerPaymentType.FASTER_PAYMENT:
      typeName = 'Faster payment';
      break;
    case PspPartnerPaymentType.SEPA_SCT:
      typeName = 'SEPA SCT';
      break;
    case PspPartnerPaymentType.SEPA_SCT_INST:
      typeName = 'SEPA SCT INST';
      break;
    case PspPartnerPaymentType.SWIFT:
      typeName = 'SWIFT';
      break;
    case PspPartnerPaymentType.TARGET_2:
      typeName = 'Target 2';
      break;
    case PspPartnerPaymentType.FEDWIRE:
      typeName = 'Fedwire';
      break;
    case PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT:
      typeName = 'Crypto Asset Payment';
      break;
    case PspPartnerPaymentType.CASH_OVER_COUNTER:
      typeName = 'Cash Over Counter';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

const TopUpInstructionItem = ({
  instruction,
  index,
  getTopUpInstructionPdf,
  pdfDownloadInProgress,
  selectedInstructionType,
}: TopUpInstructionsItemTypes) => {
  const [collapsed, setCollapsed] = useState(true);
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    copy(
      `Beneficiary: ${instruction?.beneficiary} 
Beneficiary address: ${instruction?.beneficiaryAddress || '-'} 
Beneficiary account: ${instruction?.beneficiaryAccountNumber?.join(', ')} 
Beneficiary Bank: ${instruction?.beneficiaryBankName}
${
  instruction?.paymentType === PspPartnerPaymentType.FASTER_PAYMENT ||
  instruction?.paymentType === PspPartnerPaymentType.BACS
    ? 'Beneficiary Bank Sort Code:'
    : 'Beneficiary Bank BIC:'
} ${instruction?.beneficiaryBankBIC} 
Purpose of the payment: ${instruction?.purposeOfPayment}`,
    );

    setCopyIsSuccess(true);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  return (
    <div className={cn.topupInstruction}>
      <button
        type="button"
        className={`${cn.topupInstructionTitle} ${
          collapsed ? cn.withBorder : ''
        }`}
        onClick={() => setCollapsed(!collapsed)}
      >
        {getPspPartnerPaymentType(instruction?.paymentType as string)}
        {collapsed ? (
          <IconDown width={14} height={14} />
        ) : (
          <IconUp width={14} height={14} />
        )}
      </button>
      {!collapsed && (
        <div className={cn.instructionWrapper}>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>Beneficiary:</div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiary}
            </div>
          </div>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>Beneficiary address:</div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiaryAddress || '-'}
            </div>
          </div>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>Beneficiary account:</div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiaryAccountNumber?.join(', ')}
            </div>
          </div>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>Beneficiary Bank:</div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiaryBankName}
            </div>
          </div>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>
              {instruction?.paymentType ===
                PspPartnerPaymentType.FASTER_PAYMENT ||
              instruction?.paymentType === PspPartnerPaymentType.BACS
                ? 'Beneficiary Bank Sort Code:'
                : 'Beneficiary Bank BIC:'}
            </div>
            <div className={cn.instructionRowValue}>
              {instruction?.beneficiaryBankBIC}
            </div>
          </div>
          <div className={cn.instructionRow}>
            <div className={cn.instructionRowTitle}>
              Purpose of the payment:
            </div>
            <div className={cn.instructionRowValue}>
              {instruction?.purposeOfPayment}
            </div>
          </div>
          <div className={cn.instructionControls}>
            <ButtonSecondary
              text={
                pdfDownloadInProgress &&
                selectedInstructionType === instruction?.paymentType
                  ? 'Loading...'
                  : 'Download'
              }
              icon={
                pdfDownloadInProgress &&
                selectedInstructionType ===
                  instruction?.paymentType ? undefined : (
                  <IconDownload />
                )
              }
              size={ButtonSize.SMALL}
              className={cn.downloadInstructionButton}
              onClick={() =>
                getTopUpInstructionPdf(
                  index,
                  instruction?.paymentType as PspPartnerPaymentType,
                )
              }
            />
            <div className={cn.copyButtonWrapper}>
              {copyIsSuccess && (
                <div className={cn.instructionDetailsCopied}>
                  Details copied
                </div>
              )}
              <ButtonPseudo
                text="Copy"
                icon={<IconCopy />}
                size={ButtonSize.SMALL}
                onClick={() => onCopy()}
              />
            </div>
            <div className={cn.copyButtonWrapper}>
              <ButtonPseudo
                text={pdfDownloadInProgress ? 'Loading...' : 'Send to chat'}
                icon={<IconSend />}
                size={ButtonSize.SMALL}
                disabled={pdfDownloadInProgress}
                onClick={() =>
                  getTopUpInstructionPdf(
                    index,
                    instruction?.paymentType as PspPartnerPaymentType,
                    true,
                  )
                }
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopUpInstructionItem;
